/*
 * Scenario: insert-end
 *
 * Schlaegt einen neuen Absatz nach dem letzten Text-Paragraphen vor.
 * Pendant zu insert-at-start — testet den Edge-Case "Insert ans Dokument-
 * Ende": _applyReviewInserts platziert die virtuelle Zeile nach dem letzten
 * Paragraph, EditorModel.insertParagraphAfter haengt am Ende der paragraphs[]
 * an.
 *
 * Section-Granularitaet ist in Phase C nicht modelliert (textParagraphs ist
 * eine flache Liste). Wenn das Dokument mehrere Sections hat, gilt der
 * letzte Text-Paragraph der gesamten Datei als Anker — das ist fuer das
 * Scenario gewollt einfach.
 */

import { emit, wait } from './_helpers.js'

export const name = 'insert-end'
export const description = 'Insert a new paragraph after the last text paragraph.'

export async function run(state) {
    const toolCallId = 'tu_ins_end_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-insert-end' }, 0)
    await emit(state, 'thinking', { text: 'A short epilogue could give this a real ending…' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const paras = state.context?.cursorContext?.textParagraphs || []
    if (paras.length === 0) {
        await emit(state, 'delta', { text: 'No text paragraphs to anchor an insert.' }, 100)
        await emit(state, 'done', { usage: {} }, 100)
        return
    }
    const anchor = paras[paras.length - 1]

    await emit(state, 'proposeInsert', {
        toolCallId,
        afterParagraphId: anchor.id,
        baseVersion: typeof anchor.version === 'number' ? anchor.version : undefined,
        newText: 'And so the morning rolled on, indifferent to the question that had just been asked — and the one that no one had thought to ask yet.',
        reason: 'Closes the chapter with a forward-leaning beat.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Added the closing beat. Want me to look elsewhere?'
            : 'Okay, no epilogue. The chapter ends as it was.'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
